(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ukff-artwork-request"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialiseArtworkRequests = () => {
    const params = new URLSearchParams(window.location.search);
    document.querySelectorAll('[data-ukff-artwork-form]').forEach((container) => {
      const product = container.querySelector('[data-request-product]');
      const service = container.querySelector('[data-request-service]');
      const productUrl = container.querySelector('[data-request-product-url]');
      const productLink = container.querySelector('[data-request-product-link]');
      if (product && !product.value.trim()) product.value = (params.get('product') || '').slice(0, 200);
      const requestedService = params.get('service');
      if (service && ['artwork', 'quote', 'deadline'].includes(requestedService)) service.value = requestedService;
      const productPath = params.get('product_path') || '';
      if (/^\/products\/[a-z0-9-]+$/.test(productPath)) {
        if (productUrl) productUrl.value = window.location.origin + productPath;
        if (productLink) { productLink.href = productPath; productLink.hidden = false; }
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseArtworkRequests, { once: true });
  else initialiseArtworkRequests();
  document.addEventListener('shopify:section:load', initialiseArtworkRequests);
})();
  } catch(e) { console.error(e); }
})();

})();
